<template>
    <section id="products" class="section section-shaped overflow-hidden my-0">
        <div class="shape shape-style-1 bg-gradient-gray shape-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container shape-container py-0 pb-5">
            <div class="row row-grid justify-content-between align-items-center">
                <div class="col-lg-4 mb-lg-auto">
                    <!-- <div class="transform-perspective-right"> -->
                        <img width=100% class="product-img" src="/memx-website/img/products/product.png">
                    <!-- </div> -->
                </div>
                <div class="col-lg-7">
                    <h3 class="display-3">MemX
                        <!-- <span class="text-white">completed with examples</span> -->
                    </h3>
                    <!-- <p class="lead mb-0" style="width: 110%;">Adopt MemX to power your research and applications.</p> -->
                    <p class="lead" style="width: 110%;">We would like to invite and collaborate with researchers worldwide on interactive visual intelligence, and jointly push the forefront of human-centered computing.</p>
                    <!-- <base-button tag="a" href="#contact" class="mt-3 mb-3 mb-sm-0 btn-sm btn-round button-more border-none" type="default">
                        Contact
                    </base-button> -->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
